import { Skeleton as e } from "../../Skeleton/Skeleton.js";
import t from "./TreeSkeleton.module.js";
import { c as n } from "react/compiler-runtime";
import { jsx as r, jsxs as i } from "react/jsx-runtime";
//#region src/components/Tree/TreeSkeleton/TreeSkeleton.tsx
var a = 20, o = 490, s = Array.from(Array(20)), c = () => {
	let e = n(1), i;
	return e[0] === Symbol.for("react.memo_cache_sentinel") ? (i = /* @__PURE__ */ r("div", {
		className: t.container,
		children: s.map(l)
	}), e[0] = i) : i = e[0], i;
};
function l(n, s) {
	return /* @__PURE__ */ i("div", {
		className: t.skeleton,
		children: [/* @__PURE__ */ r(e, {
			height: a,
			width: a
		}), /* @__PURE__ */ r(e, {
			height: a,
			width: o
		})]
	}, s);
}
//#endregion
export { c as TreeSkeleton };
